import { gql } from '@apollo/client';

export default gql`
  mutation processVoucherRefund(
    $amount: Float!
    $currency: Currency!
    $validUntil: String!
    $firstName: String!
    $lastName: String!
    $recipientEmail: String!
    $associatedPNR: String!
    $language: Language
    $type: String!
  ) {
    processVoucherRefund(
      amount: $amount
      currency: $currency
      validUntil: $validUntil
      firstName: $firstName
      lastName: $lastName
      recipientEmail: $recipientEmail
      associatedPNR: $associatedPNR
      language: $language
      type: $type
    ) {
      reference
    }
  }
`;
